import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FloatButton, notification } from 'antd';
import { IconButton, Grid, Typography, Button, TextField } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { getAclMenu, getToken } from '../../utils/common';
import logger from '../../utils/logger';

export default function Procedure() {
  const Endpoint = `${globalThis.REACT_APP_API_PURE}procedure/list`;
  const [data, setData] = useState([]);

  const fetchInfo = async () => {
    try {
      const response = await fetch(Endpoint, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
      });
      const data = await response.json();
      setData(data);
    } catch (error) {
      logger.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  const [message1] = React.useState('');
  const [tittles, setTittle] = React.useState('');
  const [newtittles, setNewTittle] = React.useState('');
  const [newurlparam, setNewUrl] = React.useState('');
  const [open1, setOpen1] = React.useState('');
  const [open2, setOpen2] = React.useState('');
  const [acl, setAcl] = useState(getAclMenu('procedure'));
  const [urlparam, setUrl] = React.useState('');
  const [errorText, setErrorText] = useState('');
  const [errorText1, setErrorText1] = useState('');
  const [editpass, seteditpass] = useState('');
  const [deletepass, setDeletepass] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const handleClose1 = () => {
    setOpen1(false);
    setTittle('');
    setUrl('');
    setErrorText('');
    setErrorText1('');
    setIsLoading(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
    setNewTittle('');
    setNewUrl('');
    setErrorText('');
    setErrorText1('');
    setIsLoading(false);
  };
  const handleClickOpen1 = () => {
    setOpen1(true);
    setTittle('');
    setUrl('');
  };
  const handleSubmit1 = async () => {
    setTittle('');
    setUrl('');
    try {
      setIsLoading(true);
      const apiUrl = `${globalThis.REACT_APP_API_PURE}procedure/create`;

      const headerson = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      });

      const requestOptions = {
        method: 'POST',
        headers: headerson,
        body: JSON.stringify({
          tittle: tittles,
          url: urlparam,
        }),
      };

      fetch(apiUrl, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data && data.response_code === 200) {
            notification.success({
              message: 'Success',
              description: t('ProceduresPrompt.1'),
              placement: 'top',
              duration: 5,
            });
            fetchInfo();
          } else {
            notification.error({
              message: 'Error',
              description: t('ProceduresPrompt.2'),
              placement: 'top',
              duration: 5,
            });
          }
        });
    } catch (err) {
      logger.error('Error in procedures:', err);
    }
    setTimeout(() => {
      handleClose1();
    }, 2000);
  };

  const handleedit = async () => {
    setTittle('');
    setUrl('');
    const item = {
      id: editpass.id,
      tittle: newtittles,
      url: newurlparam,
    };
    setIsLoading(true);
    fetch(`${globalThis.REACT_APP_API_PURE}procedure/edit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(item),
    })
      .then((res) => res.json())
      .then((d) => {
        if (d.response_code === 200) {
          notification.success({
            message: 'Success',
            description: t('ProceduresPrompt.3'),
            placement: 'top',
            duration: 5,
          });
        } else {
          notification.error({
            message: 'Error',
            description: data.error_message,
            placement: 'top',
            duration: 5,
          });
        }
      });

    setTimeout(() => {
      setIsLoading(false);
      fetchInfo();
      setOpen2(false);
    }, 4000);
  };
  const [isDeleteOpen, setisDeleteOpen] = useState(false);

  const handledeletess = () => {
    const formData = {
      id: deletepass?.id,
    };

    const apiUrl = `${globalThis.REACT_APP_API_PURE}procedure/delete`;

    const headerson = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    });

    const requestOptions = {
      method: 'POST',
      headers: headerson,
      body: JSON.stringify(formData),
    };

    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(t('ProceduresPrompt.5'));
        } else {
          notification.success({
            message: t('ProceduresPrompt.4'),
            placement: 'top',
            duration: 5,
          });
        }
      })
      .catch((error) => {
        logger.error('Error:', error);
      });
    fetchInfo();
    setisDeleteOpen(false);
  };

  const handletittles = (event) => {
    const newTitle = event.target.value;
    setTittle(newTitle);
    if (newTitle.trim() === '') {
      setErrorText(t('ProceduresPrompt.6'));
    } else {
      setErrorText('');
    }
  };
  const handleurls = (event) => {
    const newUrlParam = event.target.value;
    setUrl(newUrlParam);
    if (newUrlParam.trim() === '') {
      setErrorText1(t('ProceduresPrompt.7'));
    } else {
      setErrorText1('');
    }
  };

  const handleNewtittles = (event) => {
    const newTitle = event.target.value;
    setNewTittle(newTitle);
    if (newTitle.trim() === '') {
      setErrorText(t('ProceduresPrompt.6'));
    } else {
      setErrorText('');
    }
  };
  const handleNewurls = (event) => {
    const newUrlParam = event.target.value;
    setNewUrl(newUrlParam);
    if (newUrlParam.trim() === '') {
      setErrorText1(t('ProceduresPrompt.7'));
    } else {
      setErrorText1('');
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const opender = Boolean(anchorEl);

  const handleOpenDeleteModalder = () => {
    setisDeleteOpen(true);
    setAnchorEl(false);
  };
  const handleCloses = () => {
    setisDeleteOpen(false);
  };
  const handleClickers = (event, dataObj) => {
    setAnchorEl(event.currentTarget);
    seteditpass(dataObj);
  };
  const handleclickdelete = (event, dataObj, id) => {
    setAnchorEl(event.currentTarget);
    setDeletepass({ id: dataObj });
  };
  const handleClosing = () => {
    setAnchorEl(null);
  };
  const handleEditchang = () => {
    setOpen2(true);
    setAnchorEl(false);
  };

  function DialogDelete() {
    return (
      <Dialog open={isDeleteOpen} onClose={handleCloses}>
        <DialogTitle>{t('Confirmation.1')}</DialogTitle>
        <DialogContent>{t('PromptDeleteProcedure.1')}</DialogContent>
        <DialogActions>
          <Button onClick={handleCloses}>{t('Cancel.1')}</Button>
          <LoadingButton onClick={handledeletess}>{t('SubmitButton.1')}</LoadingButton>
        </DialogActions>
      </Dialog>
    );
  }

  const { t } = useTranslation();

  return (
    <div className="table-container">
      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 800, borderRadius: 2, border: '1px solid #e0e0e0' }}
          aria-label="simple table"
          className="custom-table"
        >
          <TableHead>
            <TableRow className="custom-table-row">
              <TableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>{t('title.1')}</TableCell>
              <TableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496', cursor: 'pointer' }}>
                {t('url.1')}
              </TableCell>
              <TableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496', width: '20px' }}> </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data?.data?.map((dataObj, index) => (
              <TableRow key={dataObj.index}>
                <TableCell component="th" scope="row">
                  {dataObj.tittle}
                </TableCell>
                <TableCell component="th" scope="row">
                  <a
                    href={dataObj.url.startsWith('http') ? dataObj.url : `https://${dataObj.url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {dataObj.url.length > 100 ? `${dataObj.url.substring(0, 100)}...` : dataObj.url}
                  </a>
                </TableCell>
                <TableCell component="th" scope="row" padding="none">
                  <IconButton
                    disabled={!acl?.create}
                    aria-label="more"
                    id="long-button"
                    aria-controls={opender ? 'long-menu' : undefined}
                    aria-expanded={opender ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={(event) => {
                      handleClickers(event, dataObj);
                      handleclickdelete(event, dataObj.id);
                    }}
                    style={{ color: 'blue', padding: '5px', margin: '0 5px' }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    id="long-menu"
                    MenuListProps={{
                      'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={opender}
                    onClose={handleClosing}
                  >
                    <MenuItem onClick={handleEditchang}>{t('Edit.1')}</MenuItem>
                    <Divider sx={{ my: 0.5 }} />
                    <MenuItem onClick={handleOpenDeleteModalder}>{t('DeleteUrl.1')}</MenuItem>
                  </Menu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {acl.create && (
          <FloatButton onClick={handleClickOpen1} type="primary" tooltip={<div>{t('AddProcedur.1')}</div>} />
        )}
      </TableContainer>
      <Dialog open={open1} onClose={handleClose1} aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">{t('AddProcedur.1')}</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit1} method="POST">
            <Grid container direction={'row'}>
              <Grid item xs={12}>
                <Typography align="start" variant="body2">
                  {t('title.1')}
                </Typography>
                <TextField
                  placeholder="Title"
                  id="tittles"
                  fullWidth
                  size="small"
                  type="text"
                  value={tittles}
                  onChange={handletittles}
                  error={Boolean(errorText)}
                  helperText={errorText}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography align="start" variant="body2">
                  URL
                </Typography>
                <TextField
                  placeholder="URL"
                  id="urlparam"
                  fullWidth
                  size="small"
                  type="text"
                  value={urlparam}
                  onChange={handleurls}
                  error={Boolean(errorText1)}
                  helperText={errorText1}
                />
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose1}>
            {t('Cancel.1')}
          </Button>
          <LoadingButton
            style={{ backgroundColor: isLoading ? 'gray' : '#12A2CE', color: 'white' }}
            disabled={tittles === '' || urlparam === '' || isLoading}
            type="submit"
            onClick={handleSubmit1}
            autoFocus
          >
            {t('SaveButton.1')}
          </LoadingButton>
        </DialogActions>
        <div className="message">{message1 ? <p>{message1}</p> : null}</div>
      </Dialog>
      {DialogDelete()}
      <Dialog open={open2} onClose={handleClose2} aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">{t('AddProcedur.1')}</DialogTitle>
        <DialogContent>
          <form onSubmit={handleedit} method="POST">
            <Grid container direction={'row'}>
              <Grid item xs={12}>
                <Typography align="start" variant="body2">
                  {t('title.1')}
                </Typography>
                <TextField
                  placeholder={editpass.tittle}
                  id="tittles"
                  fullWidth
                  size="small"
                  type="text"
                  value={newtittles}
                  onChange={handleNewtittles}
                  error={Boolean(errorText)}
                  helperText={errorText}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography align="start" variant="body2">
                  URL
                </Typography>
                <TextField
                  placeholder={editpass.url}
                  id="urlparam"
                  fullWidth
                  size="small"
                  type="text"
                  value={newurlparam}
                  onChange={handleNewurls}
                  error={Boolean(errorText1)}
                  helperText={errorText1}
                />
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose2}>
            {t('Cancel.1')}
          </Button>
          <LoadingButton
            style={{ backgroundColor: isLoading ? 'gray' : '#12A2CE', color: 'white' }}
            disabled={newtittles === '' || newurlparam === ''}
            type="submit"
            onClick={handleedit}
            autoFocus
          >
            {t('SaveButton.1')}
          </LoadingButton>
        </DialogActions>
        <div className="message">{message1 ? <p>{message1}</p> : null}</div>
      </Dialog>

      {}
    </div>
  );
}
